// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YM6Zm","animateOpacity":"styles_animateOpacity__oXUhU","scrollerBox":"styles_scrollerBox__t3g7O","scrollerItem":"styles_scrollerItem__pzMLt"};